import React from 'react'
import './App.css'

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './app/view/Home/Home'
import Game from './app/view/Game/Game'
import ErrorPage from './app/view/ErrorPage/ErrorPage'
import { SkeletonTheme } from 'react-loading-skeleton'
import { ScrollProvider } from './providers/scrollProvider'
import {ToastContainer} from "react-toastify";
import GameSearchPage from "./app/view/Search/search";

function App() {
  return (
    <ScrollProvider>
      <SkeletonTheme>
        <BrowserRouter>
          <Routes>
            <Route path={"/search"} element={<GameSearchPage/>}/>
            <Route path="/" element={<Home />} exact />
            <Route path="/:slug" element={<Game />} />
            {/* More specific routes go here */}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
          <ToastContainer />
        </BrowserRouter>
      </SkeletonTheme>
    </ScrollProvider>
  )
}

export default App
